import { Image } from '@ahafood/ui/components/image';
import { assetPrefix } from '@ahm/api-wrappers-core';
import React from 'react';

import type { SummaryReview } from '@/api/ahafood/get-store-fn';
import AiGen from '@/public/static/icons/ai-gen.svg';

type AiSummaryProps = {
  summary: SummaryReview;
};

export default function AiSummary({ summary }: AiSummaryProps) {
  if (!summary.percentage_negative_comment) return null;

  return (
    <div className="bg-gradient-to-br from-[#ECF6FF] to-[#FFF5F5] rounded-2xl p-4 md:p-5 border-none shadow-sm">
      {/* Header */}
      <div className="mb-3">
        <div className="flex items-start gap-2">
          <Image
            width={30}
            height={30}
            src={`${assetPrefix}/static/images/new-bot-avt.webp`}
            alt=""
          />
          <div className="flex flex-col">
            <h3 className="text-base md:text-lg text-secondary-70 font-bold flex items-center gap-2 h-5">
              Khách hàng nói gì về quán?
              <AiGen className="size-9" />
            </h3>
            {summary.general_summary && (
              <p className="text-xs md:text-sm text-primary-40 bg-[#FFFDF6] px-1 font-medium">
                {summary.general_summary}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="space-y-0 text-xs">
        {/* Highlights */}
        {summary.highlights && (
          <div>
            <p className="text-sm md:text-base">
              <span className="font-bold underline">Điểm nổi bật:</span>{' '}
              <span className="font-medium">{summary.highlights}</span>
            </p>
          </div>
        )}

        {/* Lowlights */}
        {summary.lowlights && (
          <div>
            <p className="text-sm md:text-base">
              <span className="font-bold underline">Nhận xét khác:</span>{' '}
              <span className="font-medium">
                {summary.lowlights}
                {summary.percentage_negative_comment !== undefined &&
                  summary.percentage_negative_comment > 0 && (
                    <span className="text-neutral-60">
                      {' '}
                      (~{Math.round(summary.percentage_negative_comment)}%)
                    </span>
                  )}
              </span>
            </p>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="mt-2 border-t border-primary-10/50">
        <p className="text-xs text-neutral-50 italic">
          Amori tổng hợp từ nhận xét của khách hàng
        </p>
      </div>
    </div>
  );
}
